//@import dependencies
import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, Card } from 'react-bootstrap';
//@end

//@import components
import NotesAchievedSkeleton from './notesAchievedSkeleton'
import AlertComponent from 'app_components/commons/alert'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { AiOutlineCloseCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import PaginationComponent from 'app_components/commons/pagination'
import { IPagination } from 'app_types/pagination/paginationTypes'
//@end

// @import hooks
// @end

// @INFO Import types
import {INote} from 'app_types/campus/academic/notesAchievedTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import 'react-circular-progressbar/dist/styles.css';
import './../notesAchievedModule.scss'

// @ADD Component types
interface INotesAchievedModuleLayoutProps {
  defaultStatus: boolean
  notesData: Array<INote>
  chartOptions: any
  status: 'loading' | 'error' | null
  id?: string
}



const NotesAchievedModuleLayout: React.FC<INotesAchievedModuleLayoutProps> = (props) => {

  const page: number = 1;
  const perPage: number = 5;

  const [data, setData] = useState<Array<INote>>([])
  const [activeKey, setActiveKey] = useState<string |undefined>(undefined)
  const [pagination, setPagination] = useState<IPagination | null>(null)
  const {defaultStatus} = props;

  useEffect(() => {
    const _key = defaultStatus ? '0' : undefined
    setActiveKey(_key)
  }, [defaultStatus])

  useEffect(() => {
    if (props.notesData.length > 0) {
      getDataPerPage(page)
    }
  }, [props.notesData])

  const { t } = useTranslation()

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  const renderIcon = () => {
    if (activeKey) {
      return (<AiOutlineCloseCircle size={25} />)
    }
    return (<AiOutlinePlusCircle size={25} />)
  }

  const getDataPerPage = (_page: number) => {
    const skip = (_page-1) * perPage
    const limit = skip + (perPage);
    setData(props.notesData.slice(skip,limit))
    setPagination({
      page: _page,
      perPage: perPage,
      total: props.notesData.length,
    })
  }

  const handleChangePage = (_page: number) => {
    getDataPerPage(_page)
  }

  return(
    <div id={props.id} className='notes_achieved-component'>
      <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Card.Header} eventKey={'0'}>
              <div>{t("modules.notes_achieved.title")}</div>
              <div className='icon'>
                {renderIcon()}
              </div>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              {props.status === 'loading' ? (
                <NotesAchievedSkeleton />
              ) : (
                <>
                  {data && Array.isArray(data) && data.length > 0 ? (
                    <div
                      className='container-items-note-achieved'
                    >
                    {data.map((note, index) => (
                        <div
                          className="item-note-achieved"
                          key={index}
                        >
                          <TextComponent
                            type='text'
                          >
                            {/* @ts-ignore */}
                            {note.title}
                          </TextComponent>
                          <CircularProgressbar
                            value={Math.round(note?.progress?.value || 0)}
                            text={`${Math.round(note?.progress?.value || 0)}`}
                            styles={buildStyles({
                              textSize: '2rem',
                              pathColor: note?.progress?.pathColor || undefined,
                              textColor: note?.progress?.textColor || undefined
                            })}
                          />
                        </div>
                    ))}
                    {pagination && (pagination?.total > pagination?.perPage) ? (
                      <div className='pagination-container'>
                        <PaginationComponent data={pagination} onChangePage={handleChangePage} version='v2' />
                      </div>
                    ): null}
                    </div>
                  ): (
                    <AlertComponent
                      type='warning'
                      title={t('modules.notes_achieved.no_data')}
                    />
                  )}
                </>
              ) }
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  )
}

export default NotesAchievedModuleLayout
